import React from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '@mui/material';
import Dialog from '.';
import { FullSizeCenteredColumn } from '../FlexBox';

export default function ConfirmDialog({
  open,
  onCancel,
  onSubmit,
  question,
  title,
  fontSize = '1rem',
  confirmLabel,
  cancelLabel,
  actionPosition = 'flex-end',
}) {
  const intl = useIntl();

  const handleClose = () => {
    onCancel();
  };

  return (
    <Dialog
      id="confirm-dialog"
      title={title}
      open={open}
      onClose={handleClose}
      onCancel={handleClose}
      onSubmit={onSubmit}
      cancelLabel={cancelLabel}
      submitLabel={confirmLabel}
      actionPosition={actionPosition}
      width="sm"
      minHeight="100px"
      disableBackdropClick
      disableEscapeKeyDown
      disableScroll
      dividers
    >
      <FullSizeCenteredColumn padding="24px">
        <Typography variant="body1" sx={{
          fontSize: fontSize
        }}>
          {intl.messages[question] ?? question}
        </Typography>
      </FullSizeCenteredColumn>
    </Dialog>
  );
}
